import { lazy } from 'preact/compat';

export const icons = {
  checkmark: {
    name: 'Checkmark',
    icon: lazy(
      () =>
        import(/* webpackChunkName: "icons/CheckmarkIcon" */ './CheckmarkIcon'),
    ),
  },
  candy: {
    name: 'Candy',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/CandyIcon" */ './CandyIcon'),
    ),
  },
  giftwrap: {
    name: 'Gift Wrap',
    icon: lazy(
      () =>
        import(/* webpackChunkName: "icons/GiftwrapIcon" */ './GiftwrapIcon'),
    ),
  },
  gift: {
    name: 'Gift',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/GiftIcon" */ './GiftIcon'),
    ),
  },
  multiple_gift: {
    name: 'Multiple Gift',
    icon: lazy(
      () =>
        import(
          /* webpackChunkName: "icons/MultipleGiftIcon" */ './MultipleGiftIcon'
        ),
    ),
  },
  lifebuoy: {
    name: 'Lifebuoy',
    icon: lazy(
      () =>
        import(/* webpackChunkName: "icons/LifebuoyIcon" */ './LifebuoyIcon'),
    ),
  },
  plus: {
    name: 'Plus',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/PlusIcon" */ './PlusIcon'),
    ),
  },
  star: {
    name: 'star',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/StarIcon" */ './StarIcon'),
    ),
  },
  message: {
    name: 'Message',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/MessageIcon" */ './MessageIcon'),
    ),
  },
  shield: {
    name: 'Shield',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/ShieldIcon" */ './ShieldIcon'),
    ),
  },
  diamond: {
    name: 'Diamond',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/DiamondIcon" */ './DiamondIcon'),
    ),
  },
  chat: {
    name: 'Chat',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/ChatIcon" */ './ChatIcon'),
    ),
  },
  key: {
    name: 'Key',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/KeyIcon" */ './KeyIcon'),
    ),
  },
  hearth: {
    name: 'Hearth',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/HearthIcon" */ './HearthIcon'),
    ),
  },
  thumbs_up: {
    name: 'Thumbs up',
    icon: lazy(
      () =>
        import(/* webpackChunkName: "icons/ThumbsUpIcon" */ './ThumbsUpIcon'),
    ),
  },
  truck: {
    name: 'Truck',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/TruckIcon" */ './TruckIcon'),
    ),
  },
  fast_track1: {
    name: 'Fast track 1',
    icon: lazy(
      () =>
        import(
          /* webpackChunkName: "icons/FastTrack1Icon" */ './FastTrack1Icon'
        ),
    ),
  },
  fast_track2: {
    name: 'Fast track 2',
    icon: lazy(
      () =>
        import(
          /* webpackChunkName: "icons/FastTrack2Icon" */ './FastTrack2Icon'
        ),
    ),
  },
  mystery_gift: {
    name: 'Mystery gift',
    icon: lazy(
      () =>
        import(
          /* webpackChunkName: "icons/MysteryGiftIcon" */ './MysteryGiftIcon'
        ),
    ),
  },
  vip: {
    name: 'VIP',
    icon: lazy(
      () => import(/* webpackChunkName: "icons/VIPIcon" */ './VIPIcon'),
    ),
  },
};

type Props = {
  iconKey: keyof typeof icons;
};
